const qs = require("qs");


export const convertFilterQueryParams = (params) => {

	let query = "";
	params.forEach((el) => {
		let qsEl= "";
		if(el.type === "relation" ) {
			// FORMAT OF QS FOR QUERY WITH RELATIONSHIP
			// filters: {
			// TABLERELATIONSHIP: {
			//	FIELD_IN_RELATIONSHIP: {
			// 		OPERATOR: VALUE
			// }}}

			let filters = {}
			filters[el.field] = {};
			filters[el.field][el.fieldRelation] = el.value;
			qsEl = qs.stringify(filters, {
				encodeValuesOnly: true, 
			});
		} else {
			// FORMAT OF QS
			// filters: {
			// FIELDNAME: {
			// 	OPERATOR: VALUE
			// }
			let filters = {}
			filters[el.field] = {};
			filters[el.field] = { [el.operator]: el.value };
			qsEl = qs.stringify({
					[el.field] : { 
					[el.operator]: el.value,
				}
			}, {
				encodeValuesOnly: true, // prettify URL
			});
		}

		if(query === "") {
			query += qsEl;
		} else {
			query += "&" + qsEl;
		}

	});
	
	return query;
};

